import React, { useEffect, useRef, useState } from "react";
import "../style/skill.css";

const SKILL_GROUPS = [
    {
        group: "Languages",
        items: [
            { name: "C / C++", icon: "image/c-.png", level: 90 },
            { name: "Java Programming", icon: "image/java.png", level: 90 },
            { name: "Java/Kotlin Android", icon: "image/android.png", level: 95 },
            { name: "Java/Kotlin Spring Boot", icon: "image/spring-logo.png", level: 75 },
            { name: "PHP & Laravel", icon: "/image/laravel.png", level: 95 },
            { name: ".Net MAUI", icon: "/image/maui.png", level: 90 },
            { name: "ASP .Net", icon: "/image/asp.png", level: 60 },
            { name: "Dart & Flutter", icon: "image/flutter.png", level: 95 },
            { name: "Python", icon: "image/python.webp", level: 65 },
            { name: "HTML 5", icon: "image/html-5.png", level: 90 },
            { name: "CSS3 & Bootstrap", icon: "image/css-3.png", level: 90 },
            { name: "JavaScript", icon: "image/java-script.png", level: 85 },
            { name: "React Js", icon: "/image/react.png", level: 65 },
            { name: "JQuery & Ajax", icon: "image/jquery.png", level: 90 },
            { name: "MySQL", icon: "/image/mysql.png", level: 90 },
            { name: "SQL Server", icon: "/image/sql-server.jpg", level: 80 },
            { name: "MariaDB", icon: "/image/maria.png", level: 90 },
            { name: "Postgres SQL", icon: "/image/postgresql.webp", level: 70 },
        ],
    },
    {
        group: "Deployment",
        items: [
            { name: "Firebase Cloud", icon: "/image/firebase.png", level: 70 },
            { name: "Amazon S3 & RDS", icon: "/image/aws.png", level: 75 },
            { name: "Source Control", icon: "/image/source_control.png", level: 85 },
            { name: "Docker", icon: "/image/docker.png", level: 75 },
            { name: "Linux Ubuntu", icon: "/image/ubuntu.webp", level: 85 },
        ],
    },
];

const SkillBar = ({ name, icon, level }) => {
    const barRef = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const el = barRef.current;
        if (!el) return;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.3 }
        );
        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    return (
        <div className="skill-item" ref={barRef}>
            <div className="skill-item-head">
                <div className="skill-item-label">
                    <img src={icon} width={22} height={22} alt="" className="skill-icon" />
                    <span>{name}</span>
                </div>
                <span className="skill-percent">{visible ? level : 0}%</span>
            </div>
            <div
                className="skill-track"
                role="progressbar"
                aria-valuenow={level}
                aria-valuemin={0}
                aria-valuemax={100}
            >
                <div className="skill-fill" style={{ width: visible ? `${level}%` : "0%" }} />
            </div>
        </div>
    );
};

const MySkill = () => {
    return (
        <section className="my-skill content-width" id="my-skill">
            <div className="skill-title">
                <p className="skill-eyebrow">Capabilities</p>
                <h1>My Skills</h1>
                <p className="skill-subtitle">
                    Technologies and tools I use to design, build, and ship software.
                </p>
            </div>

            <div className="the-skill">
                {SKILL_GROUPS.map((group) => (
                    <div className="skill-group" key={group.group}>
                        <h2 className="skill-group-title">{group.group}</h2>
                        <div className="skill-group-grid">
                            {group.items.map((item) => (
                                <SkillBar
                                    key={item.name}
                                    name={item.name}
                                    icon={item.icon}
                                    level={item.level}
                                />
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default MySkill;
